import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zujian",
  "use": "icon-zujian-usage",
  "viewBox": "0 0 1031 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1031 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zujian\"><defs><style type=\"text/css\"></style></defs><path d=\"M422.495 226.407l-97.74-37.845-25.11 101.070-135.585-36.382v126.653h-96.435v520.222h833.332c0 0 0-91.035 0-180.923v-13.162h66.667v-129.352h-66.667v-11.318c0-100.935 0-185.468 0-185.468h-29.768v-61.965l-385.717-194.063M346.58 230.075l363.892 149.85h-74.407l-306.292-82.192 16.807-67.657zM196.19 294.2l319.343 85.702h-319.343v-85.702zM838.745 835.438h-706.838v-387.877h706.86c0 0 0 58.073 0 129.127h-224.685v129.352h224.685c-0.023 65.183-0.023 129.398-0.023 129.398zM839.060 673.73h-192.87v-64.687h192.87v64.687zM839.060 379.903h-96.435v-20.183l-281.408-118.35 40.118-60.57 337.725 160.043v39.060z\" p-id=\"1504\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zujian.svg
// module id = ILQa
// module chunks = 83